import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { HisenseActiveFacetsModule } from './active-facets/active-facets.module';
import { HisenseFacetListModule } from './facet-list/facet-list.module';
import { HisenseProductFacetNavigationComponent } from './product-facet-navigation.component';

@NgModule({
  imports: [
    CommonModule,
    HisenseFacetListModule,
    HisenseActiveFacetsModule,
    IconModule,
    I18nModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        ProductRefinementComponent: {
          component: HisenseProductFacetNavigationComponent,
        },
      },
    }),
  ],
  declarations: [HisenseProductFacetNavigationComponent],
  exports: [HisenseProductFacetNavigationComponent],
})
export class HisenseProductFacetNavigationModule {}
